<template>
  <div
    style="display:flex;flex-direction: column;align-items: center; padding-top: 40px;"
  >
    <div>
      <span
        style="font-size: 50px;padding-bottom:10px"
        class="secondary--text font-weight-bold"
        >401</span
      >
    </div>
    <p class="text-xs-center justify-center f_18">{{ message }}</p>
    <v-flex>
      <v-btn flat color="primary" @click="reloadPage">
        <v-icon class="secondary--text">reply</v-icon>
        <span>GO BACK</span>
      </v-btn>
    </v-flex>
  </div>
</template>
<script>
export default {
  props: {
    message: {
      type: String,
      default: "Unauthorized to access content!!!"
    }
  },
  methods: {
    reloadPage() {
      window.location.reload();
    }
  },
  created() {
    this.$store.dispatch("AuthModule/getCurrentUser");
  }
};
</script>
